// extracted by mini-css-extract-plugin
module.exports = {"tablet_only":"(max-width: 1024px) and (min-width: 601px)","slider":"slider-2UE1d","compareFares":"compareFares-1lTyF","headingWrp":"headingWrp-txPi8"};